import { BASE_PATH as G, BaseAPI as B, operationServerMap as c } from "../base.js";
import { DUMMY_BASE_URL as V, assertParamExists as d, createRequestFunction as h, serializeDataIfNeeded as _, setSearchParams as F, toPathString as O } from "../common.js";
import m from "axios";
var A = function(s) {
  return {
    versionFeatureUserGroupBindUser: async (t, a = {}) => {
      d("versionFeatureUserGroupBindUser", "bindUserCommand", t);
      const n = new URL("/version_feature_user_group/bind_user", V);
      let r;
      s && (r = s.baseOptions);
      const e = {
        method: "POST",
        ...r,
        ...a
      }, o = {}, u = {};
      o["Content-Type"] = "application/json", F(n, u);
      let i = r && r.headers ? r.headers : {};
      return e.headers = {
        ...o,
        ...i,
        ...a.headers
      }, e.data = _(t, e, s), {
        url: O(n),
        options: e
      };
    },
    versionFeatureUserGroupBindVersion: async (t, a = {}) => {
      d("versionFeatureUserGroupBindVersion", "bindUserAndVersionCommand", t);
      const n = new URL("/version_feature_user_group/bind_version", V);
      let r;
      s && (r = s.baseOptions);
      const e = {
        method: "POST",
        ...r,
        ...a
      }, o = {}, u = {};
      o["Content-Type"] = "application/json", F(n, u);
      let i = r && r.headers ? r.headers : {};
      return e.headers = {
        ...o,
        ...i,
        ...a.headers
      }, e.data = _(t, e, s), {
        url: O(n),
        options: e
      };
    },
    versionFeatureUserGroupCreate: async (t, a = {}) => {
      d("versionFeatureUserGroupCreate", "createUserGroupCommand", t);
      const n = new URL("/version_feature_user_group", V);
      let r;
      s && (r = s.baseOptions);
      const e = {
        method: "POST",
        ...r,
        ...a
      }, o = {}, u = {};
      o["Content-Type"] = "application/json", F(n, u);
      let i = r && r.headers ? r.headers : {};
      return e.headers = {
        ...o,
        ...i,
        ...a.headers
      }, e.data = _(t, e, s), {
        url: O(n),
        options: e
      };
    },
    versionFeatureUserGroupDelete: async (t, a = {}) => {
      d("versionFeatureUserGroupDelete", "id", t);
      const n = "/version_feature_user_group/{id}".replace("{id}", encodeURIComponent(String(t))), r = new URL(n, V);
      let e;
      s && (e = s.baseOptions);
      const o = {
        method: "DELETE",
        ...e,
        ...a
      }, u = {};
      F(r, {});
      let i = e && e.headers ? e.headers : {};
      return o.headers = {
        ...u,
        ...i,
        ...a.headers
      }, {
        url: O(r),
        options: o
      };
    },
    versionFeatureUserGroupGetPage: async (t, a, n = {}) => {
      d("versionFeatureUserGroupGetPage", "versionFeatureUserGroup", t), d("versionFeatureUserGroupGetPage", "page", a);
      const r = new URL("/version_feature_user_group/page", V);
      let e;
      s && (e = s.baseOptions);
      const o = {
        method: "GET",
        ...e,
        ...n
      }, u = {}, i = {};
      if (t !== void 0) for (const [l, v] of Object.entries(t)) i[l] = v;
      if (a !== void 0) for (const [l, v] of Object.entries(a)) i[l] = v;
      F(r, i);
      let p = e && e.headers ? e.headers : {};
      return o.headers = {
        ...u,
        ...p,
        ...n.headers
      }, {
        url: O(r),
        options: o
      };
    },
    versionFeatureUserGroupGetUserGroupDetail: async (t, a = {}) => {
      d("versionFeatureUserGroupGetUserGroupDetail", "id", t);
      const n = "/version_feature_user_group/detail/{id}".replace("{id}", encodeURIComponent(String(t))), r = new URL(n, V);
      let e;
      s && (e = s.baseOptions);
      const o = {
        method: "GET",
        ...e,
        ...a
      }, u = {};
      F(r, {});
      let i = e && e.headers ? e.headers : {};
      return o.headers = {
        ...u,
        ...i,
        ...a.headers
      }, {
        url: O(r),
        options: o
      };
    },
    versionFeatureUserGroupGetVersionUser: async (t, a, n = {}) => {
      d("versionFeatureUserGroupGetVersionUser", "versionId", t), d("versionFeatureUserGroupGetVersionUser", "page", a);
      const r = "/version_feature_user_group/version_user/{versionId}".replace("{versionId}", encodeURIComponent(String(t))), e = new URL(r, V);
      let o;
      s && (o = s.baseOptions);
      const u = {
        method: "GET",
        ...o,
        ...n
      }, i = {}, p = {};
      if (a !== void 0) for (const [v, P] of Object.entries(a)) p[v] = P;
      F(e, p);
      let l = o && o.headers ? o.headers : {};
      return u.headers = {
        ...i,
        ...l,
        ...n.headers
      }, {
        url: O(e),
        options: u
      };
    }
  };
}, U = function(s) {
  const t = A(s);
  return {
    async versionFeatureUserGroupBindUser(a, n) {
      var r, e;
      const o = await t.versionFeatureUserGroupBindUser(a, n), u = (r = s == null ? void 0 : s.serverIndex) !== null && r !== void 0 ? r : 0, i = (e = c["VersionFeatureUserGroupApi.versionFeatureUserGroupBindUser"]) === null || e === void 0 || (e = e[u]) === null || e === void 0 ? void 0 : e.url;
      return (p, l) => h(o, m, G, s)(p, i || l);
    },
    async versionFeatureUserGroupBindVersion(a, n) {
      var r, e;
      const o = await t.versionFeatureUserGroupBindVersion(a, n), u = (r = s == null ? void 0 : s.serverIndex) !== null && r !== void 0 ? r : 0, i = (e = c["VersionFeatureUserGroupApi.versionFeatureUserGroupBindVersion"]) === null || e === void 0 || (e = e[u]) === null || e === void 0 ? void 0 : e.url;
      return (p, l) => h(o, m, G, s)(p, i || l);
    },
    async versionFeatureUserGroupCreate(a, n) {
      var r, e;
      const o = await t.versionFeatureUserGroupCreate(a, n), u = (r = s == null ? void 0 : s.serverIndex) !== null && r !== void 0 ? r : 0, i = (e = c["VersionFeatureUserGroupApi.versionFeatureUserGroupCreate"]) === null || e === void 0 || (e = e[u]) === null || e === void 0 ? void 0 : e.url;
      return (p, l) => h(o, m, G, s)(p, i || l);
    },
    async versionFeatureUserGroupDelete(a, n) {
      var r, e;
      const o = await t.versionFeatureUserGroupDelete(a, n), u = (r = s == null ? void 0 : s.serverIndex) !== null && r !== void 0 ? r : 0, i = (e = c["VersionFeatureUserGroupApi.versionFeatureUserGroupDelete"]) === null || e === void 0 || (e = e[u]) === null || e === void 0 ? void 0 : e.url;
      return (p, l) => h(o, m, G, s)(p, i || l);
    },
    async versionFeatureUserGroupGetPage(a, n, r) {
      var e, o;
      const u = await t.versionFeatureUserGroupGetPage(a, n, r), i = (e = s == null ? void 0 : s.serverIndex) !== null && e !== void 0 ? e : 0, p = (o = c["VersionFeatureUserGroupApi.versionFeatureUserGroupGetPage"]) === null || o === void 0 || (o = o[i]) === null || o === void 0 ? void 0 : o.url;
      return (l, v) => h(u, m, G, s)(l, p || v);
    },
    async versionFeatureUserGroupGetUserGroupDetail(a, n) {
      var r, e;
      const o = await t.versionFeatureUserGroupGetUserGroupDetail(a, n), u = (r = s == null ? void 0 : s.serverIndex) !== null && r !== void 0 ? r : 0, i = (e = c["VersionFeatureUserGroupApi.versionFeatureUserGroupGetUserGroupDetail"]) === null || e === void 0 || (e = e[u]) === null || e === void 0 ? void 0 : e.url;
      return (p, l) => h(o, m, G, s)(p, i || l);
    },
    async versionFeatureUserGroupGetVersionUser(a, n, r) {
      var e, o;
      const u = await t.versionFeatureUserGroupGetVersionUser(a, n, r), i = (e = s == null ? void 0 : s.serverIndex) !== null && e !== void 0 ? e : 0, p = (o = c["VersionFeatureUserGroupApi.versionFeatureUserGroupGetVersionUser"]) === null || o === void 0 || (o = o[i]) === null || o === void 0 ? void 0 : o.url;
      return (l, v) => h(u, m, G, s)(l, p || v);
    }
  };
}, y = function(s, t, a) {
  const n = U(s);
  return {
    versionFeatureUserGroupBindUser(r, e) {
      return n.versionFeatureUserGroupBindUser(r.bindUserCommand, e).then((o) => o(a, t));
    },
    versionFeatureUserGroupBindVersion(r, e) {
      return n.versionFeatureUserGroupBindVersion(r.bindUserAndVersionCommand, e).then((o) => o(a, t));
    },
    versionFeatureUserGroupCreate(r, e) {
      return n.versionFeatureUserGroupCreate(r.createUserGroupCommand, e).then((o) => o(a, t));
    },
    versionFeatureUserGroupDelete(r, e) {
      return n.versionFeatureUserGroupDelete(r.id, e).then((o) => o(a, t));
    },
    versionFeatureUserGroupGetPage(r, e) {
      return n.versionFeatureUserGroupGetPage(r.versionFeatureUserGroup, r.page, e).then((o) => o(a, t));
    },
    versionFeatureUserGroupGetUserGroupDetail(r, e) {
      return n.versionFeatureUserGroupGetUserGroupDetail(r.id, e).then((o) => o(a, t));
    },
    versionFeatureUserGroupGetVersionUser(r, e) {
      return n.versionFeatureUserGroupGetVersionUser(r.versionId, r.page, e).then((o) => o(a, t));
    }
  };
}, C = class extends B {
  versionFeatureUserGroupBindUser(s, t) {
    return U(this.configuration).versionFeatureUserGroupBindUser(s.bindUserCommand, t).then((a) => a(this.axios, this.basePath));
  }
  versionFeatureUserGroupBindVersion(s, t) {
    return U(this.configuration).versionFeatureUserGroupBindVersion(s.bindUserAndVersionCommand, t).then((a) => a(this.axios, this.basePath));
  }
  versionFeatureUserGroupCreate(s, t) {
    return U(this.configuration).versionFeatureUserGroupCreate(s.createUserGroupCommand, t).then((a) => a(this.axios, this.basePath));
  }
  versionFeatureUserGroupDelete(s, t) {
    return U(this.configuration).versionFeatureUserGroupDelete(s.id, t).then((a) => a(this.axios, this.basePath));
  }
  versionFeatureUserGroupGetPage(s, t) {
    return U(this.configuration).versionFeatureUserGroupGetPage(s.versionFeatureUserGroup, s.page, t).then((a) => a(this.axios, this.basePath));
  }
  versionFeatureUserGroupGetUserGroupDetail(s, t) {
    return U(this.configuration).versionFeatureUserGroupGetUserGroupDetail(s.id, t).then((a) => a(this.axios, this.basePath));
  }
  versionFeatureUserGroupGetVersionUser(s, t) {
    return U(this.configuration).versionFeatureUserGroupGetVersionUser(s.versionId, s.page, t).then((a) => a(this.axios, this.basePath));
  }
};
export {
  C as VersionFeatureUserGroupApi,
  A as VersionFeatureUserGroupApiAxiosParamCreator,
  y as VersionFeatureUserGroupApiFactory,
  U as VersionFeatureUserGroupApiFp
};

//# sourceMappingURL=version-feature-user-group-api.js.map